export default "__VITE_ASSET__BNdnmDN9__"